import DaysNavBar from "components/layouts/DaysNavBar.tsx";
import CategoriesNavBar from "components/layouts/CategoriesNavBar.tsx";
import { useCallback, useEffect, useState } from "react";
import { EventType } from "globals/types/models.ts";
import { useAppDispatch, useAppSelector } from "config/store";
import { useNavigate, useParams } from "react-router-dom";
import SingleEventModal from "components/modals/SingleEventModal.tsx";
import { searchActions } from "config/store/modules/search.ts";
import ShareUserLocationAutomaticModal from "components/modals/automatics/ShareUserLocationAutomaticModal.tsx";
import MapLibreLayout from "components/layouts/MapLibreLayout.tsx";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { OG_DEFAULT_IMAGE_URL } from "utils/data/global.ts";
import { useWindowScroll } from "react-use";

function MapPage(props: { name: string }) {
  const { name } = props;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const { y: scrollY } = useWindowScroll();

  const [showScrollToBtn, setShowScrollToBtn] = useState<boolean>(true);
  const isSingleEvent = name === "public-single-event";
  const currentLang = useAppSelector(state => state.global.currentLang);
  const selectedEvent: EventType | null = useAppSelector(state => state.search.selectedEvent);


  //if we scroll, dont show animation
  useEffect(() => {
    if (scrollY > 200 && showScrollToBtn) {
      setShowScrollToBtn(false);
    }
  }, [scrollY, showScrollToBtn]);

  useEffect(() => {
    if (isSingleEvent && !selectedEvent) {
      //if we are on the single event page and no event is selected, we need to fetch it by uuid
      //fetch the event
      dispatch(searchActions.getPublicEventByHandleOrUuid(params.eventHandleOrUuid as string))
        .then((event) => {
          dispatch(searchActions.setSelectedEvent(event));
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          navigate(`/map`, { replace: true });
        });
      return;
    }

    //go to the event by url if we are not on the single event page
    if (!isSingleEvent && selectedEvent) {
      //go to the event by url
      navigate(`/events/${selectedEvent.handle}`, { replace: true });
      //fetch
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSingleEvent, selectedEvent]);


  const onCloseEventModal = useCallback(() => {
    dispatch(searchActions.setSelectedEvent(null));
    navigate(`/map`, { replace: true });
  }, [dispatch, navigate]);

  const scrollToContent = useCallback(() => {
    const isSm = window.innerWidth < 768;
    window.scrollTo({
      top: window.scrollY + (isSm ? 720 : 360),
      behavior: "smooth"
    });
    setShowScrollToBtn(false);
  }, []);

  return (
    <div>
      {!selectedEvent && (
        <Helmet>
          <title>{t("seo.title")}</title>
          <meta name="description" content={t("seo.description")} />
          <meta property="og:title" content={t("seo.title")} />
          <meta property="og:description" content={t("seo.description")} />
          <meta property="og:image" content={OG_DEFAULT_IMAGE_URL} />
          <meta property="og:image:secure_url" content={OG_DEFAULT_IMAGE_URL} />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content={currentLang} />
          {/*    <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/> */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={t("seo.title")} />
          <meta name="twitter:description" content={t("seo.description")} />
          <meta name="twitter:image" content={OG_DEFAULT_IMAGE_URL} />
        </Helmet>
      )}


      <div id="map-container" className="relative">
        <DaysNavBar />
        <CategoriesNavBar showScrollToBtn={showScrollToBtn} scrollToContent={scrollToContent} />
        <div className="p-index__map">
          <MapLibreLayout />
        </div>

      </div>
      {/*
      <div className="absolute hidden md:flex z-1 bottom-[8px] right-4 flex-col justify-center items-center">
        {showScrollToBtn && (
          <div className="absolute z-0 animate-ping bg-white rounded-full inset-0" />
        )}
        <button
          className="z-2 right-4 w-20 h-20 min-w-20 rounded-full bg-white flex flex-col justify-center items-center"
          type="button" onClick={scrollToContent}>
          <Icon name="arrow-down" className="block h-8 w-8 text-black" />
        </button>

      </div>


      <HomePageContent />
*/}
      {/* Make sure we use key so the entire component will re-render */}
      <SingleEventModal key={selectedEvent?.id} onClose={onCloseEventModal} event={selectedEvent} />
      <ShareUserLocationAutomaticModal />
    </div>
  );
}

export default MapPage;
